// import http from "./http";

// export const loginUser = async (email, password) => {
//   const res = await http.post("admin_login", { email, password });

//   if (res.data.status === "success") {
//     // Save login data
//     localStorage.setItem("token", res.data.data.token ?? "");
//     localStorage.setItem("user", JSON.stringify(res.data.data));
//   }

//   return res.data;
// };


// src/services/authService.jsx
import http from "./http";

// Login (admin_login / user_login) — returns server response
export const loginUser = async (email, password) => {
  // 1. Try admin_login first
  try {
    const res = await http.post("admin_login", { email, password });
    if (res.data?.status === "success" && res.data?.data) {
      const userData = res.data.data || {};
      const token = res.data.token || userData.token;
      if (token) {
        localStorage.setItem("token", token);
        userData.token = token;
      }
      localStorage.setItem("user", JSON.stringify(userData));
      return { status: "success", data: userData, token, message: res.data.message };
    }
  } catch (err) {
    // Proceed to user_login fallback
  }

  // 2. Try user/user_login (Operator, Sales, TM, etc.)
  try {
    const resUser = await http.post("user/user_login", { email, password }, {
      headers: { "Content-Type": "application/json" }
    });

    if (
      resUser.data?.status === "success" ||
      resUser.data?.status === true ||
      resUser.data?.token ||
      (resUser.data?.data && resUser.data?.status !== "error")
    ) {
      const userData = resUser.data.data || resUser.data.user || resUser.data || {};
      const token = resUser.data.token || userData.token;
      if (token) {
        localStorage.setItem("token", token);
        userData.token = token;
      }
      localStorage.setItem("user", JSON.stringify(userData));
      return { status: "success", data: userData, token, message: resUser.data.message };
    }

    return resUser.data || { status: "error", message: "Invalid login credentials" };
  } catch (e) {
    const message = e.response?.data?.message || e.message || "Invalid credentials";
    return { status: "error", message };
  }
};

// Logout convenience
export const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  window.location.href = "/sign-in";
};
